import moment from 'moment'
import noImage from '../../../assets/images/no-image.webp'
import { MATCH_STATUS_SOON } from '../../match-discussion/constants'

export const getImageUrl = val => {
  if (val?.team?.logo) {
    return val?.team?.logo
  }

  if (val?.team?.avatar) {
    return val?.team?.avatar
  }

  return noImage
}

export const getNameTeam = val => {
  if (val?.user?.nickname) {
    return val?.user?.nickname
  }

  if (val?.team?.name) {
    return val?.team?.name
  }

  return ''
}

export const isNumber = val => {
  return Number.isFinite(val) ? val : '-'
}

export const getStartMatchDate = date => {
  const testDateUtc = moment.utc(date)
  return moment(testDateUtc).local().format('D MMMM YYYY, h:mm a (UTC Z)')
}

export const getStatusClass = status => {
  if (status === MATCH_STATUS_SOON) return 'upcoming'
  if (status === 'live' || status === 'ongoing') return 'live'
  return 'completed'
}

export const getGameName = game => {
  return game?.name ? game?.name : game?.title ? game?.title : ''
}

export const getStatusText = status => {
  return status === MATCH_STATUS_SOON
    ? 'Upcoming'
    : status === 'live' || status === 'ongoing'
      ? 'Live'
      : 'Completed'
}
